import { Dropdown } from 'react-bootstrap-5';
import React from 'react';
import { SidebarSearch } from 'components/search_sidebar/sidebar_search';
import PropTypes from 'prop-types';

export default function TagTopBar({
  handleTagSearch,
  openDeleteTagsModal,
  openMergeTagsModal,
  openNewTagModal,
  searchValue,
  selectedTagsLength
}) {
  return (
    <div className="d-flex align-items-center justify-content-between mb-3 mt-2">
      <SidebarSearch
        name="search_text"
        placeholder="Search current tags"
        value={searchValue}
        onChange={handleTagSearch}
      />
      <div>
        <div className="btn-group dropdown me-2">
          <Dropdown className="actions-dropdown" id="actions-dropdown">
            <Dropdown.Toggle>
              Actions
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item disabled={selectedTagsLength < 2} key="merge-records" onClick={openMergeTagsModal}>
                Merge Tags
              </Dropdown.Item>
              <Dropdown.Item disabled={selectedTagsLength < 1} key="delete-group" onClick={openDeleteTagsModal}>
                Delete Tags
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <button
          className="btn btn-primary ms-2"
          onClick={openNewTagModal}
        >
          + Add New
        </button>
      </div>
    </div>
  );
}

TagTopBar.propTypes = {
  handleTagSearch: PropTypes.func.isRequired,
  openDeleteTagsModal: PropTypes.func.isRequired,
  openMergeTagsModal: PropTypes.func.isRequired,
  openNewTagModal: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  selectedTagsLength: PropTypes.number.isRequired
};
